export default {
	getSeoInfo: '/admin/seo', // SEO收录信息
	seoUpset: '/admin/seo/upset', //重新生成报告
};
